import MqttClient from '@/v2/infraestructure/mqtt/mqttClient'
import { useUserStore } from '@/v2/application/stores/userStore'
import { useDevicesStore } from '@/v2/application/stores/devicesStore'

export const createClient = () => {
    const userStore = useUserStore();
    const brokerUrl = "wss://mqtt.cvis.videri.ai";
    const options = {
        clientId: `mqtt_${Math.random().toString(16).slice(3)}`,
        protocolVersion: 5,
        clean: true,
        connectTimeout: 5*1000,
        reconnectPeriod: 1000,
        username: userStore.getUsername(),
        password: userStore.getPassword(),
        path: '/mqtt'
    }
    const mqttClient = new MqttClient(brokerUrl, options);
    return mqttClient;
}

const handlerExample = (message, topic) => {
    const deviceSn = topic.split('/')[2];
    const devicesStore = useDevicesStore();
    const telemetry = JSON.parse(message);
    devicesStore.setDeviceTelemetry(deviceSn, telemetry.data);
}

export const setupMqttClient = (mqttClient) => {
    const devicesStore = useDevicesStore();
    const ids = devicesStore.getAllDevicesIds();
    for (const id of ids) {
        const topic = `thing/product/${id}/osd`;
        mqttClient.subscribe(topic, handlerExample);
    }
}